import { render, staticRenderFns } from "./authResetPassSuccess.vue?vue&type=template&id=7f5301e8&scoped=true"
import script from "./authResetPassSuccess.vue?vue&type=script&lang=js"
export * from "./authResetPassSuccess.vue?vue&type=script&lang=js"
import style0 from "./authResetPassSuccess.vue?vue&type=style&index=0&id=7f5301e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5301e8",
  null
  
)

export default component.exports